<script setup>
import { ref } from 'vue';
import ReportHeader from '../../settings/reports/components/ReportHeader.vue';
import GmSummaryReports from '../components/GmSummaryReports.vue';
import GmEnhancedAgentMetricsTable from '../components/GmEnhancedAgentMetricsTable.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summarReportsRef = ref(null);
const enhancedMetricsRef = ref(null);

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};

const onDownloadEnhancedClick = () => {
  enhancedMetricsRef.value.downloadReports();
};

</script>

<template>
  <div class="enhanced-agent-performance-page">
    <!-- Original Agent Performance Matrix -->
    <ReportHeader
      :header-title="$t('GM_ANALYTICS.AGENT_PERFORMANCE_MATRIX.HEADER')"
      :header-description="$t('GM_ANALYTICS.AGENT_PERFORMANCE_MATRIX.DESCRIPTION')"
    >
      <V4Button
        :label="$t('GM_ANALYTICS.AGENT_PERFORMANCE_MATRIX.DOWNLOAD_REPORTS')"
        icon="i-ph-download-simple"
        size="sm"
        @click="onDownloadClick"
      />
    </ReportHeader>

    <GmSummaryReports
      ref="summarReportsRef"
      action-key="gmAnalytics/fetchAgentPerformanceMatrix"
      getter-key="agents/getAgents"
      fetch-items-key="agents/get"
      summary-key="gmAnalytics/getAgentPerformanceMatrix"
      type="agent"
    />


    <!-- Enhanced Agent Metrics Table -->
    <div class="mt-8">
      <GmEnhancedAgentMetricsTable ref="enhancedMetricsRef" />
    </div>
  </div>
</template>

<style scoped>
.enhanced-agent-performance-page {
  padding: 1rem;
}

.mt-8 {
  margin-top: 2rem;
}
</style>
